// Excel が CSV を開く際に "1-2" を日付("1月2日")へ自動変換するのを防ぐためのユーティリティ。
//
// 値を Excel の文字列リテラル式 ="..." で囲むと、Excel はセルを文字列として扱い日付変換しない。
// また ="..." は数式として評価されてもリテラル文字列を返すため、CSV 数式インジェクション
// (=cmd 等)も無害化される（exportDataAsCsv の escapeFormulas を無効化しても安全）。
// 空文字・null・undefined・非文字列はそのまま返す。
export const escapeForExcelText = (value: string | null | undefined): string | null | undefined => {
  if (!value) return value;

  return `="${value.replace(/"/g, '""')}"`;
};

const excelCsvUtil = { escapeForExcelText };

export default excelCsvUtil;
